<template>
  <div>
    <div class="columns is-vcentered table-header pd-t-3 is-hidden-mobile">
      <div class="column has-text-centered" v-for="head in column">
        <p
          class="cr-pointer text-grey"
          :class="{ 'has-text-secondary': currentSort === head.name }"
          @click="sortBy(head.name)"
        >
          {{ head.title }}
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == head.name"
          ></span>
        </p>
      </div>
      <div class="column is-1"></div>
    </div>

    <div v-if="formDataList.length == 0" class="has-text-centered pd-y-3">
      <p class="is-size-4"></p>
      <p class="is-size-6">*** ขณะนี้ยังไม่มีข้อมูล Form ***</p>
      <p class="is-size-4"></p>
    </div>

    <div
      v-else
      class="columns listData is-vcentered mg-y-3"
      v-for="(item, index) in formDataList"
      :key="index"
    >
      <div class="column is-1 has-text-right is-hidden-tablet">
        <b-dropdown position="is-bottom-left" class="dropdown-action">
          <a slot="trigger">
            <b-tooltip label="More" position="is-bottom" type="is-white">
              <b-icon
                pack="fas"
                icon="ellipsis-v"
                class="text-light-grey"
              ></b-icon>
            </b-tooltip>
          </a>

          <b-dropdown-item @click="gotoFormData(item, true)">
            <p>ดูรายการ</p>
          </b-dropdown-item>

          <b-dropdown-item @click="gotoFormData(item, false)">
            <p>แก้ไขรายการ</p>
          </b-dropdown-item>

          <b-dropdown-item @click="delFormDateid(item._id)">
            <p>ลบรายการ</p>
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <!-- {{item}} -->
      <div class="column has-text-centered" v-for="title in column">
        <div v-if="title.type != 'checkbox'">
          <span class="is-hidden-tablet has-text-weight-semibold"
            >{{ title.title }}: </span
          >{{ getDataSelect(item, title) }}
        </div>
        <div v-else>
          <div
            class="font-14"
            v-for="(data, key) in getDataSelect(item, title)"
          >
            {{ data.label }}
          </div>
        </div>
      </div>
      <!--             <div class="column is-2 has-text-centered" >
                <p><span class="is-hidden-tablet has-text-weight-semibold">ตำบล: </span>{{getSubDistrict(item)}}</p>
            </div>
            <div class="column is-2  has-text-centered">
                <p><span class="is-hidden-tablet has-text-weight-semibold">หมู่ที่: </span>{{getVillageNo(item)}}</p>
            </div>
            <div class="column is-2 has-text-centered">
                <p><span class="is-hidden-tablet has-text-weight-semibold">หมู่บ้าน: </span>{{getVillageNanme(item)}}</p>
            </div>
            <div  class="column is-3 has-text-centered" >
                <p><span class="is-hidden-tablet has-text-weight-semibold">แก้ไขล่าสุดเมื่อ: </span>{{item.updatedAt | dateTimeTh}}</p>
            </div> -->
      <div class="column is-1 has-text-right is-hidden-mobile">
        <b-dropdown position="is-bottom-left" class="dropdown-action">
          <a slot="trigger">
            <b-tooltip label="More" position="is-bottom" type="is-white">
              <b-icon
                pack="fas"
                icon="ellipsis-v"
                class="text-light-grey"
              ></b-icon>
            </b-tooltip>
          </a>

          <b-dropdown-item @click="gotoFormData(item, true)">
            <p>ดูรายการ</p>
          </b-dropdown-item>

          <b-dropdown-item @click="gotoFormData(item, false)">
            <p>แก้ไขรายการ</p>
          </b-dropdown-item>

          <b-dropdown-item @click="delFormDateid(item._id)">
            <p>ลบรายการ</p>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { HTTP } from "@/service/axios.js";
export default {
  props: ["data", "formDataListConst", "column"],
  data() {
    return {
      currentSort: "",
      formDataList: [],
      currentSortDir: "desc",
    };
  },
  watch: {
    data() {
      this.formDataList = this.data;
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  mounted() {
    this.formDataList = this.data;
  },
  methods: {
    sortBy(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = s;
      this.sortData();
    },
    sortData() {
      this.formDataList = this.formDataList.sort((a, b) => {
        let modifier = 1;
        if (this.currentSortDir === "desc") modifier = -1;
        if (this.currentSort === "district") {
          if (this.getDataSelect(a) < this.getDataSelect(b)) {
            return -1 * modifier;
          }
          if (this.getDataSelect(a) > this.getDataSelect(b)) {
            return 1 * modifier;
          }
        } else if (this.currentSort === "subDistrict") {
          if (this.getSubDistrict(a) < this.getSubDistrict(b)) {
            return -1 * modifier;
          }
          if (this.getSubDistrict(a) > this.getSubDistrict(b)) {
            return 1 * modifier;
          }
        } else if (this.currentSort === "villageNo") {
          if (Number(this.getVillageNo(a)) < Number(this.getVillageNo(b))) {
            return -1 * modifier;
          }
          if (Number(this.getVillageNo(a)) > Number(this.getVillageNo(b))) {
            return 1 * modifier;
          }
        } else if (this.currentSort === "village") {
          if (this.getVillageNanme(a) < this.getVillageNanme(b)) {
            return -1 * modifier;
          }
          if (this.getVillageNanme(a) > this.getVillageNanme(b)) {
            return 1 * modifier;
          }
        } else {
          if (a.updatedAt < b.updatedAt) return -1 * modifier;
          if (a.updatedAt > b.updatedAt) return 1 * modifier;
        }
        return 0;
      });
    },
    getDataSelect(obj, label) {
      let input = obj.data[0].input;
      if (
        typeof input[label.name] !== "undefined" &&
        input[label.name] !== null &&
        input[label.name].data !== null
      ) {
        if (label.type == "select") {
          return input[label.name].label;
        } else if (label.type == "radio") {
          return input[label.name].data.label;
        } else {
          return input[label.name];
        }
      }
      return "";
    },
    getDistrict(obj, label) {
      let input = obj.data[0].input;
      if (typeof input[label] !== "undefined") {
        return input[label];
      }

      if (
        typeof input.DistrictEcn !== "undefined" &&
        input.DistrictEcn !== null
      ) {
        return input.DistrictEcn;
      }

      return "";
    },
    getSubDistrict(obj) {
      let input = obj.data[0].input;
      if (typeof input.subDistrict !== "undefined") {
        return input.subDistrict;
      }

      if (
        typeof input.subDistrictEcn !== "undefined" &&
        input.subDistrictEcn !== null
      ) {
        return input.subDistrictEcn;
      }

      return "";
    },
    getVillageNo(obj) {
      let input = obj.data[0].input;
      if (typeof input.villageNo !== "undefined") {
        return input.villageNo;
      }

      if (
        typeof input.villageNoEcn !== "undefined" &&
        input.villageNoEcn !== null
      ) {
        return input.villageNoEcn;
      }

      return "";
    },
    getVillageNanme(obj) {
      let input = obj.data[0].input;
      if (typeof input.villageNo !== "undefined") {
        return input.villageNo;
      }

      if (
        typeof input.villageEcn !== "undefined" &&
        input.villageEcn !== null
      ) {
        return input.villageEcn;
      }

      return "";
    },
    gotoFormData(data, status) {
      this.$emit("goToDetail", data);
      this.$emit("setViewComponent", status);
    },

    delFormDateid(id) {
      this.$buefy.dialog.confirm({
        message: "หากต้องการลบข้อมูล กรุณากดตกลง?",
        confirmText: "ตกลง",
        cancelText: "ยกเลิก",
        type: "is-danger",
        onConfirm: () => this.confrimDel(id),
      });
    },
    confrimDel(id) {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
      HTTP.delete(`del/${id}`).then((res) => {
        if (res.data.success) {
          this.$emit("fetchDataForm");
        }
      });
    },
  },
};
</script>
<style scoped>
.listData {
  background: #ffffff;
  border: 1px solid #dbdbdb;
  box-sizing: border-box;
  border-radius: 4px;
}
</style>
